import { useQuery } from 'react-query';
import { getServiceById } from '~/api/services';

export const useService = (serviceId: string | undefined) => {
  return useQuery(
    ['services', serviceId],
    () => getServiceById(serviceId!).then((res) => res.data),
    {
      enabled: !!serviceId,
    }
  );
};
